import { LOGIN } from './actionTypes';

export const login = (task) => {
  return {
    type: LOGIN,
    payload: task,
  };
};
